import { useEffect } from 'react';

// Full-height shells (h-[var(--app-height)]) scroll internally, so the window should
// never scroll. iOS Safari still scrolls the page to reveal a focused input when the
// on-screen keyboard opens, pushing the shrunken shell off-screen over a blank gap —
// pin the window back whenever that happens.
const useViewportScrollLock = () => {
  useEffect(() => {
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    let raf = null;

    const pin = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        if (vv && vv.scale > 1.01) return; // pinch-zoomed: let the user pan freely
        const el = document.scrollingElement;
        if (window.scrollX || window.scrollY || el?.scrollTop || el?.scrollLeft) {
          window.scrollTo(0, 0);
          if (el) {
            el.scrollTop = 0;
            el.scrollLeft = 0;
          }
        }
      });
    };

    pin();

    window.addEventListener('scroll', pin);
    if (vv) {
      vv.addEventListener('scroll', pin);
      vv.addEventListener('resize', pin);
    }

    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('scroll', pin);
      if (vv) {
        vv.removeEventListener('scroll', pin);
        vv.removeEventListener('resize', pin);
      }
    };
  }, []);
};

export default useViewportScrollLock;
